import React from "react";
import { connect } from "react-redux";
import { ModalHeader } from "reactstrap";
import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import { ModalFooter } from "reactstrap";
import { Button } from "reactstrap";
import { Field, getFormValues, reduxForm } from "redux-form";
import {SelectField} from "common-fields";
import {TextField} from "common-fields";
import "./saveDocument.scss";
import { MessageModel } from "../../models/MessageCenterModels";

interface SaveDocumentModalProps {
  showDocumentHandler: (m: MessageModel) => void;
  closeSaveDocumentModalHandler: () => void;
  allClinetsData: any;
  locationsData: any;
  selectedClientId: string;
  onDocSaveHandler: (body: any) => void;
  loadLoctions: (clientId: string) => void;
}

const SaveDocumentModal: React.FC = (props: any) => {
  const saveHandler = () => {
    const saveData: any = {
      docTitle: props.formValues.documentTitle,
      location: props.formValues.location,
      clientUUID: props.formValues.clientName,
    };
    props.onDocSaveHandler(saveData);
  };
  const clientNameChange = (clientId:any) =>{
    if(clientId){
      props.loadLoctions(clientId);
    }
  }
  return (
    <div className="saveDocumentModalContainer">
      <Modal
        className=" mw-50 w-50 saveDocumentModalWraper"
        isOpen={true}
        fade={false}
        toggle={props.showDocumentHandler}
      >
        <ModalHeader toggle={props.closeSaveDocumentModalHandler}>
          Save Document
        </ModalHeader>
        <ModalBody>
          <div className="SaveDocumentForm ">
            <form>
              <div className=" formText mb-3">
                <Field
                  component={SelectField}
                  name="clientName"
                  label={"Select Client:"}
                  HelpText={"Select Client"}
                  values={props.allClinetsData}
                  disabled={props.selectedClientId}
                  onChange={(e: any) => {
                    clientNameChange(e);
                  }}
                />
                <Field
                  component={TextField}
                  type="text"
                  name="documentTitle"
                  label="Document Title"
                />
                <Field
                  component={SelectField}
                  name="location"
                  label={"Location:"}
                  HelpText={"Location"}
                  values={props.locationsData}
                />
              </div>
            </form>
          </div>
        </ModalBody>
        <ModalFooter className="d-flex flex-row justify-content-center">
          <Button className="docSaveBtn" onClick={saveHandler}>
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

const mapStateToProps = (
  state: Record<string, unknown>,
  props: SaveDocumentModalProps
) => {
  return {
    initialValues: {
      clientName: props.selectedClientId,
    },
    formValues: getFormValues("CreateSaveDocumentModal")(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "CreateSaveDocumentModal", // a unique identifier for this form
    enableReinitialize: true,
  })(SaveDocumentModal)
);
